
import React, { useRef } from 'react';
import { Button } from 'primereact/button';
import { Menu } from 'primereact/menu';
import { Toast } from 'primereact/toast';

import {  useLocation , useNavigate } from "react-router-dom";



export default function MenuHeader() {
    const menuLeft = useRef(null);
    const menuRight = useRef(null);
    const toast = useRef(null);
    
    const navigate = useNavigate() ;

    const items = [
        {
            label: 'Opciones',
            items: [
                {
                    label: 'Iniciar Sesión',
                    icon: 'pi pi-user' , 
                    command: () => {
                        navigate( "/session" , { state : { isClient : false } })

                        //  navigate("/session" , { state : { isClient : true } }) // Lo forzamos a cliente
                    }
                },
                {
                    label: 'Encuentra un Abogado',
                    icon: 'pi pi-search' ,
                    command: () => {
                        //navigate( "/abogados")
                        navigate( "/clientmenu" , { state : { id : 0 }})

                        //navigate( "/agenda" , { state : { id :0 }})
                    }
                },
                {
                    label: 'Consulta Express',
                    icon: 'pi pi-key' ,
                    command: () => {
                        //navigate( "/session" , { state : { isClient : false } })
                        //navigate( "/clientmenu" , { state : { id : 0 }})
                        navigate( "/express" , { state : { id : 0 }})
                    }
                },
                {
                    label: 'Encuentra Documentos',
                    icon: 'pi pi-book'
                },
                {
                    label: 'Soy Abogado',
                    icon: 'pi pi-address-book' ,
                    command: () => {
                        navigate( "/abogados")
                    }

                },
                {
                    label: 'Soy Cliente',
                    icon: 'pi pi-users' ,
                    command: () => {
                        navigate( "/clientes")
                    }

                },
                {
                    label: 'Dashboard',
                    icon: 'pi pi-wave-pulse'

                } ,

                {
                    label: 'Inicio',
                    icon: 'pi pi-home',
                    command: () => {
                        navigate( "/")
                }

                } ,





                // pi-address-book


            ]
        }
    ];

    return (
        <div className=" flex justify-content-end " style={{borderWidth:0 }}>
            <Toast ref={toast}></Toast>
            {/* <Menu model={items} popup ref={menuLeft} id="popup_menu_left" />
            <Button label="Show Left" icon="pi pi-align-left" className="mr-2" onClick={(event) => menuLeft.current.toggle(event)} aria-controls="popup_menu_left" aria-haspopup /> */}
            <Menu model={items} popup ref={menuRight} id="popup_menu_right" popupAlignment="right" />
            <Button  icon="pi pi-align-right" size='large' style={{color:'black' , backgroundColor : 'white' , borderWidth:0 }} 
                className="mr-0" onClick={(event) => menuRight.current.toggle(event)} aria-controls="popup_menu_right" aria-haspopup />
        </div>
    )
}
        